import { Injectable, Injector } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

/**
 * Route `title`s are translation keys (pageTitles.*). Translates them for the
 * browser tab and re-applies the current one when the language changes.
 *
 * TranslateService is resolved lazily: the Router injects the TitleStrategy while it is being
 * constructed, so a constructor dependency on TranslateService can close a DI cycle at startup.
 */
@Injectable({ providedIn: 'root' })
export class TranslatedTitleStrategy extends TitleStrategy {
  private currentKey?: string;
  private translate?: TranslateService;

  constructor(
    private readonly title: Title,
    private readonly injector: Injector,
  ) {
    super();
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    this.currentKey = this.buildTitle(snapshot);
    this.apply();
  }

  private apply(): void {
    if (!this.translate) {
      this.translate = this.injector.get(TranslateService);
      this.translate.onLangChange.subscribe(() => this.apply());
    }
    if (this.currentKey) {
      this.title.setTitle(this.translate.instant(this.currentKey));
    }
  }
}
